import { Autocomplete, debounce, Grid, TextField } from "@mui/material"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useOcupacaoService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useEffect, useState } from "react"
import { IOcupacao } from "../../../../../../../application/models"

export const RecorteCBO = () => {
    // State
    const { ocupacoes, searchTerm } = useAppSelector((state) => state.ocupacao)
    const { openForm, editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Use State
    const [selectedCBO, setSelectedCBO] = useState<IOcupacao[]>([])
    // Hook
    const {
        setCategoria,
        setSearchTerm,
        searchOcupacoes,
        resetCategoria,
        resetOcupacoes,
        resetSearchTerm
    } = useOcupacaoService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const cbosSelecionados = editRecorteExtracaoForm.fields.Filtros?.cbo || [];

        if (cbosSelecionados.length > 0) {
            setSelectedCBO(cbosSelecionados);
        } else {
            setSelectedCBO([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.cbo]);

    // Filtra as opções para remover os itens já selecionados
    const filteredOcupacoes = ocupacoes.filter((ocupacao: IOcupacao) =>
        !selectedCBO.some((selected: IOcupacao) => selected.cbocodigo === ocupacao.cbocodigo)
    );

    // Functions
    const debouncedSetSearchTerm = debounce((newSearchTerm: string) => {
        setCategoria('cbosearch')
        setSearchTerm(newSearchTerm);
    }, 500);

    const handleCBOSelectionChange = (value: IOcupacao[]) => {
        setSelectedCBO(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'cbo',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'cbo',
                formType: 'edit'
            });
        }
    }

    // Use Effect
    useEffect(() => {
        if (searchTerm.length > 0) {
            searchOcupacoes()
        }
    }, [searchOcupacoes, searchTerm])

    useEffect(() => {
        resetCategoria()
        resetOcupacoes()
        resetSearchTerm()
    }, [openForm, resetCategoria, resetOcupacoes, resetSearchTerm])

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredOcupacoes}
                    getOptionLabel={(option: IOcupacao) => option.cbodescricao ? `${option.cbocodigo} - ${option.cbodescricao.toUpperCase()}` : ''}
                    sx={{
                        px: 2
                    }}
                    value={selectedCBO}
                    onInputChange={(event, newInputValue) => {
                        debouncedSetSearchTerm(newInputValue)
                    }}
                    onChange={(event, value: IOcupacao[]) => {
                        handleCBOSelectionChange(value);
                    }}
                    noOptionsText={searchTerm.length > 1 ? 'Nenhum CBO encontrado' : 'Digite o número ou descrição do CBO'}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Ocupações"
                        />
                    )}
                />
            </Grid>
        </>
    )
}